import React, { useEffect } from 'react';
import Pagination from '@mui/material/Pagination';

const PaginationComponent = ({ totalPages, currentPage, setCurrentPage, style = {} }) => {
  const handleChange = (e, v) => {
    setCurrentPage(v);
  };

  useEffect(() => {
    if (currentPage <= 0) {
      setCurrentPage(1);
    }
    if (currentPage > totalPages) {
      setCurrentPage(totalPages);
    }
  }, [totalPages, currentPage]);

  const paginationStyles = {
    width: '100%',
    marginBottom: 20,
    display: 'grid',
    placeItems: 'center',
    ...style,
  };

  return (
    <div style={paginationStyles}>
      <Pagination count={totalPages} color="primary" page={currentPage} onChange={handleChange} />
    </div>
  );
};

export default PaginationComponent;
